import { SubPackageSlugEnum } from '@yaotai/common-utils';

export const ACCOUNT_BIND_CODE_NUMBER = 6;

export const USER_CENTER_URL = `/${SubPackageSlugEnum.Center}/user/info`;
